

















































import {
  DashboardService,
  FaturamentoDetalhado,
} from "@/services/dashboard.service";
import { moeda } from "@/shared/filters";
import GlobalMixin from "@/shared/mixins/globalMixin";
import dayjs from "dayjs";
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";

interface PivotRow {
  tipoMeioPagamento: string;
  meioPagamento: string;
  recebidoEm: string;
  dias: { [dia: string]: number };
  total: number;
}

@Component({
  filters: { moeda },
})
export default class FinanceiroDiario extends Mixins(GlobalMixin) {
  @Prop() readonly value!: string;

  rawData: FaturamentoDetalhado[] = [];
  loading = false;

  pivotData: PivotRow[] = [];

  diasDoMes: string[] = [];

  totalPorDia: { [dia: string]: number } = {};
  totalGeral = 0;

  @Watch("value", { immediate: true })
  async onMesAnoChange(mesAno: string) {
    this.loading = true;
    this.rawData = await DashboardService.faturamentoDetalhado(mesAno);
    this.processPivot(mesAno);
    this.loading = false;
  }

  /**
   * Processa os dados brutos e gera a estrutura pivot
   */
  processPivot(mesAno: string) {
    const ini = dayjs(`${mesAno}-01`);
    const qtdDias = ini.daysInMonth();
    this.diasDoMes = [];
    for (let i = 1; i <= qtdDias; i++) {
      const diaStr = i.toString().padStart(2, "0");
      this.diasDoMes.push(diaStr);
    }

    const grupoMap: { [key: string]: PivotRow } = {};

    this.totalPorDia = {};
    this.totalGeral = 0;
    for (const dia of this.diasDoMes) {
      this.totalPorDia[dia] = 0;
    }

    this.rawData.forEach((item) => {
      const dia = dayjs(item.dataPagamento).format("DD");
      const key = `${item.tipoMeioPagamento}__${item.meioPagamento}__${item.recebidoEm}`;
      if (!grupoMap[key]) {
        grupoMap[key] = {
          tipoMeioPagamento: item.tipoMeioPagamento,
          meioPagamento: item.meioPagamento,
          recebidoEm: item.recebidoEm,
          dias: {},
          total: 0,
        };
      }
      grupoMap[key].dias[dia] = (grupoMap[key].dias[dia] || 0) + item.total;
      grupoMap[key].total += item.total;

      this.totalPorDia[dia] += item.total;
      this.totalGeral += item.total;
    });

    this.pivotData = Object.values(grupoMap);
  }
}
